export { FontSizeModal } from './FontSizeModal';
